<template>
  <form @submit.prevent="confirmUpdate()" action="">
    <ion-row>
      <ion-col size="12">
        <ion-list>
          <ion-item v-if="validationError" lines="none">
            <ion-label className="ion-text-wrap">
              <ion-text color="danger">
                <p v-for="error of v$.$errors" :key="error.$uid">
                  <ion-icon
                    :ios="alertCircleOutline"
                    :md="alertCircleSharp"
                    size="small"
                    style="vertical-align: middle"
                  ></ion-icon
                  >{{ error.$property }}: {{ error.$message }}
                </p></ion-text
              >
            </ion-label>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.name.$error }">
            <ion-label position="floating">Name</ion-label>
            <ion-input type="text" v-model="name"></ion-input>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.description.$error }">
            <ion-label position="floating">Description</ion-label>
            <ion-input type="text" v-model="description"></ion-input>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.amount.$error }">
            <ion-label position="floating"
              >Amount in Rupees (without tax)</ion-label
            >
            <ion-input type="number" v-model="amount"></ion-input>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.tax_rate.$error }">
            <ion-label position="floating">Tax rate</ion-label>
            <ion-select v-model="tax_rate" :value="tax_rate">
              <ion-select-option
                v-for="taxRate of taxRates"
                :key="taxRate.id"
                :value="taxRate.value"
              >
                {{ taxRate.value }} %
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.is_mandatory.$error }">
            <ion-label position="floating">Is mandatory?</ion-label>
            <ion-select v-model="is_mandatory" :value="is_mandatory">
              <ion-select-option value="1"> Yes </ion-select-option>
              <ion-select-option value="0"> No </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.assign_students.$error }">
            <ion-label position="floating">Assign all students?</ion-label>
            <ion-select
              v-model="assign_students"
              :value="assign_students"
              :disabled="is_mandatory == '1'"
            >
              <ion-select-option value="1"> Yes </ion-select-option>
              <ion-select-option value="0"> No </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button type="submit" expand="full" class="ion-margin-vertical">
          Save
        </ion-button>
      </ion-col>
    </ion-row>
  </form>
</template>

<script>
import {
  IonRow,
  IonCol,
  IonList,
  IonLabel,
  IonItem,
  IonButton,
  IonSelect,
  IonSelectOption,
  IonInput,
  IonText,
  IonIcon,
  loadingController,
  alertController,
} from "@ionic/vue";

import { alertCircleOutline, alertCircleSharp } from "ionicons/icons";

import { required, requiredIf, maxLength, integer, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },
  emits: ["closeModal"],
  components: {
    IonRow,
    IonCol,
    IonList,
    IonLabel,
    IonItem,
    IonButton,
    IonSelect,
    IonSelectOption,
    IonInput,
    IonText,
    IonIcon,
  },
  data() {
    return {
      id: this.resource.id,
      name: this.resource.name,
      description: this.resource.description,
      amount: this.resource.amount_in_cent / 100,
      tax_rate: this.resource.tax_rate,
      is_mandatory: this.resource.is_mandatory == true ? "1" : "0",
      assign_students: null,

      taxRates: [
        { id: 0, value: 0 },
        { id: 1, value: 5 },
        { id: 2, value: 12 },
        { id: 3, value: 18 },
        { id: 4, value: 28 },
      ],

      alertCircleOutline,
      alertCircleSharp,

      validationError: null,
      xhrError: {
        header: null,
        description: null,
      },
    };
  },

  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return {
      name: {
        required: helpers.withMessage("cannot be empty", required),
        maxLength: helpers.withMessage(
          "maximum 255 characters",
          maxLength(255)
        ),
      },
      description: {
        required: helpers.withMessage("cannot be empty", required),
        maxLength: helpers.withMessage(
          "maximum 255 characters",
          maxLength(255)
        ),
      },
      amount: {
        required: helpers.withMessage("is required", required),
        integer: helpers.withMessage("can only be integers", integer),
        maxLength: helpers.withMessage("maximum 5 characters", maxLength(5)),
      },
      tax_rate: {
        required: helpers.withMessage("is required", required),
        integer: helpers.withMessage("can only be integers", integer),
      },

      is_mandatory: {
        required: helpers.withMessage("is required", required),
        integer: helpers.withMessage("can only be integers", integer),
      },
      assign_students: {
        requiredIfNotMandatory: helpers.withMessage(
          "is required",
          requiredIf(this.is_mandatory == "0")
        ),
        integer: helpers.withMessage("can only be integers", integer),
      },
    };
  },

  methods: {
    setModalState(state) {
      this.modalState = state;
    },

    loader(message) {
      const loading = loadingController.create({
        message: message,
        backdropDismiss: false,
      });

      return loading;
    },

    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    setErrorResponse(error) {
      if (error.response) {
        this.xhrError.header = error.response.data.header;
        this.xhrError.message = error.response.data.message;
      } else if (error.request) {
        this.xhrError.header = error.message || error.request;
        this.xhrError.message = "Please check your connection and try again";
      } else {
        this.xhrError.header = error.message;
        this.xhrError.message = "Something went wrong. Try again later";
      }
    },

        async confirmUpdate() {
      const header = `Confirm`;
      const message = "Are you sure you want to save changes?";
      const buttons = [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: "Okay",
          handler: () => {
            this.updateChargeable();
          },
        },
      ];
      const alertDialog = await this.alerter(header, message, buttons);

      alertDialog.present();
    },

    async updateChargeable() {
      this.v$.$touch();
      if (this.v$.$error) {
        this.validationError = true;
        return;
      }

      let data = {
        id: this.id,
        name: this.name,
        description: this.description,
        amount: this.amount,
        tax_rate: this.tax_rate,
        is_mandatory: this.is_mandatory,
        assign_students: this.assign_students,
      };

      const spinner = await this.loader("Saving...");
      spinner.present();

      try {
        await this.$store.dispatch("chargeable/updateResource", data);
        spinner.dismiss();

        this.name = null;
        this.$emit("closeModal");
      } catch (error) {
        spinner.dismiss();

        this.setErrorResponse(error);

        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );

        alertDialog.present();

        this.password = null;
        this.validationError = null;
      }
    },
  },
};
</script>
